<app-table
  [service]="courseService"
  pageFunctionName="findCourses"
  [cols]="cols()"
  modelName="cursos"
  addLabel="Novo curso"
  (booleanAction)="updateCourseStatus($event)"
/>
<p-toast />
